var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,99.9c-27.6,0-50-22.4-50-50C0,24,19.4,2.6,45.1,0.1c1.6-0.2,3.2,0.7,3.9,2.2c0.7,1.5,0.3,3.3-0.9,4.4 c-6.3,5.9-9.7,13.9-9.7,22.4c0,17,13.8,30.9,30.9,30.9c9.3,0,18-4.1,23.9-11.3c1-1.3,2.8-1.7,4.3-1.2c1.5,0.6,2.6,2.1,2.5,3.7 C99.2,78.6,77.3,99.9,50,99.9z M35.8,10C19.3,15.8,7.7,31.5,7.7,49.9c0,23.3,19,42.3,42.3,42.3c19.5,0,35.9-13,40.8-31 c-6.3,4.2-13.7,6.5-21.5,6.5c-21.3,0-38.6-17.3-38.6-38.6C30.7,22.3,32.5,15.8,35.8,10z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkicon);
export default __webpack_public_path__ + "static/media/darkicon.22fefe620e006e4b018345178e84ef58.svg";
export { ForwardRef as ReactComponent };